import React, { Component } from 'react';
import { navigateTo } from '../utils/navigation';

var config = process.env;

// Diferencias entre NUESTRO precio de venta y el precio de lista del proveedor.
//
// El orden es por diferencia descendente porque estar MÁS CARO que el proveedor es el riesgo
// comercial concreto: el cliente puede comprar el mismo juego más barato en el propio
// distribuidor. Estar más barato es, casi siempre, una decisión (liquidación) — se muestra
// igual, pero abajo.
class TablePriceReviewComponent extends Component {

    constructor(props) {
        super(props);
        this.state = {
            filter: 'all',
            accepting: null,
            matching: null,
            // Marcada por defecto (decisión del dueño): lo normal es que ML quede al mismo
            // precio que la web. Se destilda para un ajuste puntual.
            updateMl: true
        };
    }

    accept = (row) => {
        const note = window.prompt(
            `Vas a aceptar que "${row.name}" quede a $${row.ourPrice} mientras el proveedor lo publica a $${row.supplierPrice}.\n\n¿Por qué? (opcional)`,
            ''
        );
        // `null` = canceló. Una nota vacía es válida.
        if (note === null) {
            return;
        }
        this.setState({ accepting: row.code });
        const request = {
            method: 'PUT',
            headers: {
                'access-token': localStorage.getItem('token'),
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({ note })
        };
        fetch(`${config.REACT_APP_BASE_URL}${config.REACT_APP_VERSION}supplier-sync/price-review/${encodeURIComponent(row.prefix)}/${row.code}/accept`, request)
        .then(res => res.json())
        .then(data => {
            this.setState({ accepting: null });
            if (data.error > 0) {
                alert(data.message);
            } else if (this.props.onChange) {
                this.props.onChange();
            }
        })
        .catch(() => this.setState({ accepting: null }));
    }

    // Iguala nuestro precio al del proveedor. Pide confirmación mostrando los dos números: es una
    // escritura sobre el precio de venta, no un ajuste cosmético.
    match = (row) => {
        const { updateMl } = this.state;
        const ok = window.confirm(
            `"${row.name}"\n\nNuestro precio: $${row.ourPrice}\nPrecio del proveedor: $${row.supplierPrice}\n\n¿Ajustar nuestro precio a $${row.supplierPrice}?` +
            (updateMl ? '\n\nTambién se va a actualizar el precio en MercadoLibre (mismo precio que la web).' : '')
        );
        if (!ok) {
            return;
        }
        this.setState({ matching: row.code });
        const request = {
            method: 'PUT',
            headers: {
                'access-token': localStorage.getItem('token'),
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({ updateMl })
        };
        fetch(`${config.REACT_APP_BASE_URL}${config.REACT_APP_VERSION}supplier-sync/price-review/${encodeURIComponent(row.prefix)}/${row.code}/match`, request)
        .then(res => res.json())
        .then(data => {
            this.setState({ matching: null });
            if (data.error > 0) {
                alert(data.message);
                return;
            }
            const resumen = this.resumenMl(data.data && data.data.ml);
            if (resumen) {
                alert(resumen);
            }
            if (this.props.onChange) {
                this.props.onChange();
            }
        })
        .catch(() => {
            this.setState({ matching: null });
            alert('No se pudo ajustar el precio. Probá de nuevo.');
        });
    }

    // Qué pasó en MercadoLibre. El precio del catálogo ya cambió aunque ML falle, así que esto se
    // muestra siempre que haya publicaciones: lo que no se actualizó hay que hacerlo a mano.
    resumenMl = (ml) => {
        if (!ml || !ml.listings) {
            return null;
        }
        if (ml.skipped) {
            return `El precio se ajustó, pero MercadoLibre quedó sin cambiar.\n\n${ml.skipped}`;
        }
        const lineas = ml.results.map(r => r.ok
            ? `✓ ${r.externalItemId}: $${r.previousPrice} → $${r.newPrice}`
            : `✗ ${r.externalItemId}: ${r.message}`);
        const fallas = ml.results.filter(r => !r.ok).length;
        const titulo = fallas === 0
            ? 'Precio ajustado, también en MercadoLibre.'
            : 'El precio se ajustó, pero algunas publicaciones de MercadoLibre quedaron sin cambiar:';
        return `${titulo}\n\n${lineas.join('\n')}`;
    }

    // Debajo de cada precio: cuánto deja sobre el costo.
    renderMarkup = (row, pct) => {
        if (pct == null) {
            return <div style={{ fontSize: '11px' }} className="text-muted">sin costo</div>;
        }
        const clase = pct < 0 ? 'text-danger' : 'text-muted';
        return (
            <div style={{ fontSize: '11px' }} className={clase} title={`Costo $${row.cost}. (precio − costo) / costo, con IVA en los dos lados.`}>
                {pct > 0 ? '+' : ''}{pct}% s/costo
            </div>
        );
    }

    filtered = () => {
        const { rows } = this.props;
        switch (this.state.filter) {
            case 'expensive': return rows.filter(r => r.diff > 0);
            case 'cheaper': return rows.filter(r => r.diff < 0);
            case 'changed': return rows.filter(r => r.supplierPriceChangedAt);
            default: return rows;
        }
    }

    renderFilter = (key, label, count) => (
        <button
            type="button"
            className={`btn btn-sm ${this.state.filter === key ? 'btn-primary' : 'btn-outline-secondary'}`}
            style={{ marginRight: '6px' }}
            onClick={() => this.setState({ filter: key })}
        >
            {label} <span className="badge badge-light">{count}</span>
        </button>
    )

    render() {
        const { rows } = this.props;
        const visible = this.filtered();

        if (!rows || rows.length === 0) {
            return (
                <div className="alert alert-success">
                    Todos los precios coinciden con los del proveedor.
                </div>
            );
        }

        return (
            <div className="card card-small mb-4">
                <div className="card-header border-bottom" style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', flexWrap: 'wrap', gap: '8px' }}>
                    <div>
                        {this.renderFilter('all', 'Todas', rows.length)}
                        {this.renderFilter('expensive', 'Más caros', rows.filter(r => r.diff > 0).length)}
                        {this.renderFilter('cheaper', 'Más baratos', rows.filter(r => r.diff < 0).length)}
                        {this.renderFilter('changed', 'Cambió el proveedor', rows.filter(r => r.supplierPriceChangedAt).length)}
                    </div>
                    <label className="mb-0" style={{ fontSize: '13px', cursor: 'pointer' }}
                           title="Al tocar «Ajustar al proveedor», las publicaciones de MercadoLibre vinculadas quedan al mismo precio que la web.">
                        <input
                            type="checkbox"
                            checked={this.state.updateMl}
                            onChange={(e) => this.setState({ updateMl: e.target.checked })}
                            style={{ marginRight: '6px' }}
                        />
                        Al ajustar, actualizar también MercadoLibre
                    </label>
                </div>
                <div className="card-body p-0">
                    <table className="table mb-0">
                        <thead className="bg-light">
                            <tr>
                                <th scope="col" className="border-0">Producto</th>
                                <th scope="col" className="border-0" style={{ textAlign: 'right' }}>Nuestro</th>
                                <th scope="col" className="border-0" style={{ textAlign: 'right' }}>Proveedor</th>
                                <th scope="col" className="border-0" style={{ textAlign: 'right' }}>Diferencia</th>
                                <th scope="col" className="border-0" style={{ textAlign: 'center' }}>Stock</th>
                                <th scope="col" className="border-0" style={{ textAlign: 'right' }}>Acciones</th>
                            </tr>
                        </thead>
                        <tbody>
                            {visible.map(row => {
                                const masCaro = row.diff > 0;
                                return (
                                    <tr key={`${row.prefix}-${row.code}`}>
                                        <td>
                                            {row.name}
                                            <div style={{ fontSize: '11px' }} className="text-muted">
                                                SKU {row.sku}
                                                {row.previouslyAccepted && (
                                                    <span className="badge badge-warning" style={{ marginLeft: '6px' }}
                                                          title="Ya habías aceptado una diferencia para este producto, pero el proveedor cambió el precio.">
                                                        el proveedor cambió el precio
                                                    </span>
                                                )}
                                                {!row.supplierInStock && (
                                                    <span className="badge badge-secondary" style={{ marginLeft: '6px' }}>
                                                        sin stock en proveedor
                                                    </span>
                                                )}
                                            </div>
                                        </td>
                                        <td style={{ textAlign: 'right' }}>
                                            ${row.ourPrice}
                                            {this.renderMarkup(row, row.ourMarkupPct)}
                                        </td>
                                        <td style={{ textAlign: 'right' }}>
                                            ${row.supplierPrice}
                                            {this.renderMarkup(row, row.supplierMarkupPct)}
                                        </td>
                                        <td style={{ textAlign: 'right' }}>
                                            <strong className={masCaro ? 'text-danger' : 'text-success'}>
                                                {masCaro ? '+' : ''}{row.diffPct}%
                                            </strong>
                                        </td>
                                        <td style={{ textAlign: 'center' }}>{row.stock}</td>
                                        <td style={{ textAlign: 'right', whiteSpace: 'nowrap' }}>
                                            <button
                                                type="button"
                                                className="btn btn-sm btn-primary"
                                                style={{ marginRight: '6px' }}
                                                disabled={this.state.matching === row.code}
                                                title={`Dejar nuestro precio en $${row.supplierPrice}, igual al del proveedor.`}
                                                onClick={() => this.match(row)}
                                            >
                                                {this.state.matching === row.code ? 'Ajustando…' : 'Ajustar al proveedor'}
                                            </button>
                                            <button
                                                type="button"
                                                className="btn btn-sm btn-outline-primary"
                                                style={{ marginRight: '6px' }}
                                                onClick={() => navigateTo(`/editProduct?code=${row.code}`)}
                                            >
                                                Editar
                                            </button>
                                            <button
                                                type="button"
                                                className="btn btn-sm btn-outline-secondary"
                                                disabled={this.state.accepting === row.code}
                                                title="Dejar el precio como está. Si el proveedor cambia el suyo, la diferencia vuelve a aparecer."
                                                onClick={() => this.accept(row)}
                                            >
                                                Está bien así
                                            </button>
                                        </td>
                                    </tr>
                                );
                            })}
                        </tbody>
                    </table>
                </div>
            </div>
        );
    }
}

export default TablePriceReviewComponent;
